import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';
interface PageHeroProps {
  language: Language;
  titleEn: string;
  titlePs: string;
  introEn: string;
  introPs: string;
}
export function PageHero({
  language,
  titleEn,
  titlePs,
  introEn,
  introPs
}: PageHeroProps) {
  const isPashto = language === 'pashto';
  return <section className="relative pt-12 pb-8 md:pt-20 md:pb-10 px-6 overflow-hidden bg-gradient-to-b from-pasoon-green/30 to-white" data-id="element-220">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-pasoon-green/20 rounded-full blur-[120px] pointer-events-none -translate-y-1/2 translate-x-1/4" data-id="element-221"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-222">
        <motion.div key={language} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-223">
          <h1 className={`text-4xl md:text-6xl font-bold text-pasoon-dark mb-4 ${isPashto ? 'font-pashto leading-normal' : 'font-serif'}`} data-id="element-224">
            {isPashto ? titlePs : titleEn}
          </h1>
          <div className="w-24 h-1 bg-pasoon-red mx-auto mb-5 rounded-full" data-id="element-225"></div>
          <p className={`text-lg md:text-xl text-gray-600 max-w-2xl mx-auto ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-226">
            {isPashto ? introPs : introEn}
          </p>
        </motion.div>
      </div>
    </section>;
}